<template>
  <div class="mobile-box">
    <van-nav-bar title="资料编号" left-arrow @click-left="back" />
    <div class="info">

      <van-cell-group inset>
        <van-cell v-for="(item,index) in dataList" :key="index" :title="item"  />
      </van-cell-group>

    </div>
  </div>
</template>
<script>
import './mobile.less'
export default {
  name: '',
  components: {},
  props: {},
  data() {
    return {}
  },
  created() {
    // invoice contract
  },
  mounted() { },
  computed: {
    dataList() {
      return this.$route.params.dataList
    }
  },
  methods: {
    back() {
      this.$router.go(-1)
    }
  },
}
</script>
<style scoped lang="less">
  /deep/ .van-icon-arrow-left {
    color: #a5a5a5 !important;
  }
</style>


// WEBPACK FOOTER //
// src/mobile/DataInfo.vue